import { render } from "./DeliveryTtnBlock.vue?vue&type=template&id=3eeef53c&scoped=true"
import script from "./DeliveryTtnBlock.vue?vue&type=script&lang=js"
export * from "./DeliveryTtnBlock.vue?vue&type=script&lang=js"

import "./DeliveryTtnBlock.vue?vue&type=style&index=0&id=3eeef53c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eeef53c"]])

export default __exports__